import { Component, OnInit } from '@angular/core';
import { AbstractFormWidgetComponent } from '../../../../../shared/components/widget/abstract-form-widget/abstract-form-widget.component';
import { ResourceService, NavigationService, AlertService, UserService } from 'sce-core';
import { LeftPanelService, DatePickerConfigService } from 'sce-ui-lib';
import { InventoryAdjustmentDataEditorService } from '../../service/inventory-adjustment-editor.service';
import { InventoryAdjustmentDataService } from '../../service/inventory-adjustment-data.service';

@Component({
  selector: 'lfwms-inv-adjustment-primary-accordion',
  templateUrl: './inv-adjustment-primary-accordian.component.html',
  styleUrls: ['./inv-adjustment-primary-accordian.component.css']
})
export class  InvAdjustmentPrimaryAccordianComponent extends AbstractFormWidgetComponent implements OnInit {
  public dataEditor: InventoryAdjustmentDataEditorService;
  public dataService: InventoryAdjustmentDataService;

  constructor(protected resourceService: ResourceService,
    protected navService: NavigationService,
    protected leftPanelService: LeftPanelService,
    protected alertService: AlertService,
    protected userService: UserService,
    protected dateConfigService: DatePickerConfigService) {
      super(resourceService, navService, leftPanelService, alertService, userService, dateConfigService);
    }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/features/inventory/inventory-adjustment/inv-adjustment-home/inv-adjustment-primary-accordian/inv-adjustment-primary-accordian.component.ts